import { render } from "./RestoreIcon.vue?vue&type=template&id=74d4924f"
import script from "./RestoreIcon.vue?vue&type=script&lang=js"
export * from "./RestoreIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__